import { COMMON_RESOURCES } from "@dl/declarations";
import * as yup from "yup";

export type RoleFormData = {
  _id?: string;
  name: string;
  permissions: string[];
};

export const initialValues: RoleFormData = {
  name: "",
  permissions: Object.values(COMMON_RESOURCES).map(
    (resource) => `${resource.ROUTE}:`
  ),
};

export const schema = yup.object().shape({
  name: yup.string().required().label("Name"),
  permissions: yup.array().of(yup.string()).required().label("Permissions"),
});
